export type AuthLocationState = {
  from?: string;
};

export function authRedirectTarget(state: AuthLocationState | null | undefined, fallback = "/"): string {
  const target = state?.from;
  if (!target?.startsWith("/") || target.startsWith("//")) return fallback;
  if (target === "/login" || target === "/register") return fallback;
  return target;
}
